import { STORAGE_CONSTANT } from "./constants";

const getModulesList = () => {
  let updatedModules = JSON.parse(
    localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)
  );
  if (updatedModules && typeof updatedModules === "object") {
    return Object.keys(updatedModules);
  }
  return undefined;
};

export const checkRoutePermission = (modulesInReverseOrder = []) => {
  let currentRouteModule = undefined;
  for (let i = 0; i < modulesInReverseOrder.length; ++i) {
    if (modulesInReverseOrder[i]) {
      currentRouteModule = modulesInReverseOrder[i];
      break;
    }
  }
  if (!currentRouteModule) return true;
  if (!JSON.parse(localStorage.getItem(STORAGE_CONSTANT.NEW_MODULES)))
    return false;
  let updatedModules = getModulesList();
  return updatedModules.includes(currentRouteModule);
};
